import { useSelector } from 'react-redux';
import { selectBulkOperations } from './bulkOperationsSlice';
export function useIsBulkUpdated(threadId) {
  const bulkOperations = useSelector(selectBulkOperations);
  // since bulkOperations is a JS object the key is cast to a string anyways
  const index = threadId;
  return !!bulkOperations[index];
}